import { Button } from '@/components/ui/button';
import { RocketIcon } from 'lucide-react';

export const GithubInstructions = () => {
  const url = 'https://github.com/apps/praetorian-chariot/installations/new';

  return (
    <div>
      <p className="mb-4 block text-sm leading-6">
        Install the Chariot GitHub App in your organization:
      </p>
      <div>
        <Button
          onClick={() => {
            window.document.location = url;
          }}
          className="rounded-xs p-1!"
        ><RocketIcon />Install GitHub App</Button>
      </div>
      <div className="relative mt-4">
        <span className="bg-chariot-background-primary text-chariot-text-primary sticky left-[200px] z-10 px-4">
          OR
        </span>
        <hr className="border-chariot-stroke absolute top-3 w-full" />
        <p className="mb-4 block text-sm leading-6">
          Provide a Workspace access token and your organization name
        </p>
      </div>
    </div>
  );
};

export const BitbucketAuthInstructions = () => {
  const url = 'https://bitbucket.org/install-chariot';

  return (
    <div>
      <p className="mb-4 block text-sm leading-6">
        Install the Chariot Bitbucket App in your organization:
      </p>
      <div>
        <Button
          onClick={() => {
            window.document.location = url;
          }}
          className="rounded-xs"
        ><RocketIcon />Install Bitbucket App</Button>
      </div>
      <div className="relative mt-4">
        <span className="bg-chariot-background-primary text-chariot-text-primary sticky left-[200px] z-10 px-4">
          OR
        </span>
        <hr className="border-chariot-stroke absolute top-3 w-full" />
        <p className="mb-4 block text-sm leading-6">
          Provide a Workspace access token and your organization name
        </p>
      </div>
    </div>
  );
};
